import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45a3a8bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "faq container",
  id: "faq"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "faq__title-wrapper" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "main-title" }, "Частые вопросы"),
  /*#__PURE__*/_createElementVNode("p", { class: "faq__title-wrapper-text" }, " Нам часто задают вопросы о ремонте, сроках и процессе. Ниже мы приводим список самых популярных из них. ")
], -1))
const _hoisted_3 = { class: "faq-items" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Да, например:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Заказать только визуализацию."),
  /*#__PURE__*/_createElementVNode("li", null, "Использовать более доступные аналоги материалов из проекта."),
  /*#__PURE__*/_createElementVNode("li", null, "Отказаться от авторского надзора (но риски ошибок возрастут).")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Да, в пакете «ДИЗАЙН - ПРОЕКТ» мы полностью комплектуем интерьер: от дивана до вазочек. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Чтобы вы были абсолютно уверены в результате, на старте мы всегда предлагаем несколько базовых вариантов концепции. Если ни один из них вам не откликнется, мы готовы полностью переработать дизайн до трех раз без каких-либо доплат, пока не найдем ваше идеальное решение! ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "После вашего согласия:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Подписываем договор."),
  /*#__PURE__*/_createElementVNode("li", null, "Вы вносите 50% оплату проекта."),
  /*#__PURE__*/_createElementVNode("li", null, "Мы выезжаем на замеры — и начинаем творческий процесс!")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppCollapse = _resolveComponent("AppCollapse")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppCollapse, { title: "Можно ли сэкономить на реализации дизайн-проекта?" }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_AppCollapse, { title: "Вы подбираете мебель и декор?" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_AppCollapse, { title: "Что если нам не понравится концепция?" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_AppCollapse, { title: "Как начинается работа?" }, {
        default: _withCtx(() => [
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_AppCollapse, { title: "Можно ли увидеть примеры ваших работ?" }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _createTextVNode(" Конечно! Вот "),
            _createVNode(_component_router_link, { to: "/projects" }, {
              default: _withCtx(() => [
                _createTextVNode("портфолио")
              ]),
              _: 1
            }),
            _createTextVNode(". Там есть проекты в разных стилях — вы сможете оценить наш подход. ")
          ])
        ]),
        _: 1
      })
    ])
  ]))
}